//**auto-generated don't edit this code**//
import {ContractHttpClient, getClientConfig} from '@esgi/contracts';
import {Disposable} from '@esgi/core/service';
import {callback} from './endpoints/callback';
import {authCallback} from './endpoints/auth-callback';
import {auth} from './endpoints/auth';
import {authGetUserUrl} from './endpoints/auth-get-user-url';
import {authGetStudentUrl} from './endpoints/auth-get-student-url';
import {linkingLink} from './endpoints/linking-link';
import {linkingUnlink} from './endpoints/linking-unlink';
import {authByNotLinked} from './endpoints/auth-by-not-linked';

export class IntegrationsCleverController implements Disposable {
	private httpClientConfig = getClientConfig('sso-apigateway');
	private httpClient: ContractHttpClient = new ContractHttpClient(this.httpClientConfig);

	public callback = callback(this.httpClient);
	public authCallback = authCallback(this.httpClient);
	public auth = auth(this.httpClient);
	public authGetUserUrl = authGetUserUrl(this.httpClient);
	public authGetStudentUrl = authGetStudentUrl(this.httpClient);
	public linkingLink = linkingLink(this.httpClient);
	public linkingUnlink = linkingUnlink(this.httpClient);
	public authByNotLinked = authByNotLinked(this.httpClient);

	public dispose(): void {
		this.httpClient?.destroy();
	}
}
